<ng-template #popContent >
  <div class="am-popover-seat text-am-white" [ngClass]="{
'premiermodal': classType === 'FIRST_CLASS',
'amplusmodal': classType === 'AM_PLUS',
'preferredmodal': classType === 'PREFERRED',
'coachgenmodal': classType === 'COACH',
'exitmodal': classType === 'EXIT_ROW'
}">
    <div class="am-popover-header-seat">
      <div class="am-popover-selectionFor-seat fs-18px text-am-white">
        {{currentPassenger.displayName | titlecase}}
      </div>
      <div class="am-popover-close-seat">
        <img alt="" class="am-popover-close-seat" src="../../../../assets/images/closeSlim.svg" />
      </div>
    </div>
    <div class="am-popover-body-seat2">
      <div class="am-popover-seat fs-32px">
        {{ name }}
      </div>
      <div class="fs-18px opacity-60">
        <span> {{ seatDesc | translate}} </span>
      </div>
    </div>
    <div class="am-popover-footer-seat">
      <div class="am-popover-benefits-seat">
        <div class="am-popover-benefitItem-seat" *ngFor="let item of benefits">
          <img alt="" [src]="item.path">
        </div>
      </div>
      <div class="am-popover-button-seat" (click)="validateCost()">
        <button class="am-button-seat text-am-white-seat rounded-pill fs-20px bg-red border-0" 
        (click)="validateCost()" style="color: white;"
        [disabled]="disabledCostButton">
          <span *ngIf="cost > 0">{{cost | amCurrency}}</span>
          <span *ngIf="cost == 0">{{'seatReview.optionBtnSelection' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<div [ngbPopover]="status !== 2?popContent:null" [popoverClass]="asignateClass()" [ngClass]="{
'palinbnt': classType === 'FIRST_CLASS'  && (column === 'D' || column === 'G' || column === 'E'),
'palinbnt2': classType === 'FIRST_CLASS'  && column === 'D' && row === '9',
'palinbntL': classType === 'FIRST_CLASS' && column === 'A',
'palinbntC': classType === 'FIRST_CLASS'  && (column === 'C'),
'palinbntC1': classType === 'FIRST_CLASS'  && column === 'C' && row === '1',
'palinbntJ': classType === 'FIRST_CLASS'  && (column === 'J'),
'palibntD8': classType === 'FIRST_CLASS' && row === '8' && column === 'J',
'palinbntrow5': classType === 'FIRST_CLASS' && column === 'D' && row === '5',
'aalinbntL': classType === 'AM_PLUS'  && (column === 'A'),
'aalinbnt': classType === 'AM_PLUS'  && (column === 'D' || column === 'G'),
'aalinbntC': classType === 'AM_PLUS'  && column === 'C',
'pralinbnt': classType === 'PREFERRED'  && (column === 'D' || column === 'G'),
'pralinbntG': classType === 'PREFERRED'  && column === 'G' && row === '25',
'pralinbntC': classType === 'PREFERRED'  && column === 'C',
'calinbntrowsep': classType === 'COACH' && column === 'D' && row === '33',
'calinbntC': classType === 'COACH'  && column === 'C',
'calinbnt': classType === 'COACH'  && (column === 'D' || column === 'G'),
'calinbntDG': classType === 'COACH' && (column === 'D' || column === 'G') && row === '39',
'calinbntD': classType === 'COACH' && column === 'D' && row === '40',
'ealinbnt': classType === 'EXIT_ROW'  && (column === 'D' || column === 'G'),
'ealinbntC': classType === 'EXIT_ROW'  && column === 'C',
'calinbnt34': classType === 'COACH' && column === 'D' && row === '34'
}">

  <ng-container *ngFor="let rowFirst of firstRows">
  <div *ngIf="row == rowFirst.firstRow || rowFirst.exitRows.includes(+row) " [ngClass]="{
  'letterColumn': row == rowFirst.firstRow && classType !== 'EXIT_ROW',
  'letterColumn2': airplane === 'P7379' && row === '16',
  'letterColumnExit': airplane === 'P7379' && row === '17',
  'letterColumnExit1P180': airplane === 'P180' && row === '14',
  'letterColumnExit2P180': airplane === 'P180' && row === '15'
  }">
    {{ column }}
  </div>
</ng-container>

  <button  class="am-seat Center" [disabled]="status == 2"   [ngClass]="{
'pseatL': classType === 'FIRST_CLASS' && (column === 'A' || column === 'C' || column === 'E'),
'pseatLF': classType === 'FIRST_CLASS' && (column === 'F'),
'pseatCenter': classType === 'FIRST_CLASS' && (column === 'F' || column === 'D'),
'pseatRR': classType === 'FIRST_CLASS' && (column === 'D' ||column === 'J'),
'pseatR': classType === 'FIRST_CLASS' && (column === 'D' || column === 'F' || column === 'G' || column === 'J' || column === 'B'),
'pseatBorder': classType === 'FIRST_CLASS' && ((column === 'A' || column === 'C' || column === 'G' || column === 'J') && (row === '4' )),
'pseatD': status == 2 && !isSelected,
'aseatL': classType === 'AM_PLUS' && (column === 'A' || column === 'D' || column === 'G'),
'aseatCenter': classType === 'AM_PLUS' && (column === 'D' || column === 'E' || column === 'F'),
'aseatC': classType === 'AM_PLUS' && (column === 'B' || column === 'E' || column === 'H'),
'aseatR': classType === 'AM_PLUS' && (column === 'C' || column === 'F' || column === 'J'),
'aseatL90': classType === 'AM_PLUS' && (column === 'A' || column === 'C'),
'aseatR90': classType === 'AM_PLUS' && (column === 'B' || column === 'D'),
'prseatL': classType === 'PREFERRED' && (column === 'A' || column === 'D' || column === 'G'),
'prseatC': classType === 'PREFERRED' && (column === 'B' || column === 'E' || column === 'H'),
'prseatCenter': classType === 'PREFERRED' &&(column === 'D' || column === 'E' || column === 'F'),
'prseatR': classType === 'PREFERRED' && (column === 'C' || column === 'F' || column === 'J'),
'prseatL90': classType === 'PREFERRED' && (column === 'A' || column === 'C'),
'prseatR90': classType === 'PREFERRED' && (column === 'B' || column === 'D'),
'cseatL': classType === 'COACH' && (column === 'A' || column === 'D' || column === 'G'),
'cseatCenter': classType === 'COACH' && ((column === 'D' || column === 'E' || column === 'F') && (row != '21' && row != '22')),
'cseatC': classType === 'COACH' && (column === 'B' || column === 'E' || column === 'H'),
'cseatR': classType === 'COACH' && (column === 'C' || column === 'F' || column === 'J'),
'cseatL90': classType === 'COACH' && (column === 'A' || column === 'C'),
'cseatR90': classType === 'COACH' && (column === 'B' || column === 'D'),
'eseatL': classType === 'EXIT_ROW' && (column === 'A' || column === 'D' || column === 'G'),
'eseatC': classType === 'EXIT_ROW' && (column === 'B' || column === 'E' || column === 'H'),
'eseatR': classType === 'EXIT_ROW' && (column === 'C' || column === 'F' || column === 'J'),
'eseatL90': classType === 'EXIT_ROW' && (column === 'A' || column === 'C'),
'eseatR90': classType === 'EXIT_ROW' && (column === 'B' || column === 'D'),

'pseatRedL': isSelected && classType === 'FIRST_CLASS' && (column === 'A' || column === 'E'),
'pseatRedR': isSelected && classType === 'FIRST_CLASS' && (column === 'B' || column === 'F'|| column === 'J'),
'seatRedM':  airplane !== 'PE190' && isSelected && (classType === 'AM_PLUS' || classType === 'PREFERRED' || classType === 'COACH' || classType === 'EXIT_ROW') && (column === 'B' || column === 'E' || column === 'H'),
'seatRedR':  airplane !== 'PE190' && isSelected && (classType === 'AM_PLUS' || classType === 'PREFERRED' || classType === 'COACH' || classType === 'EXIT_ROW') && (column === 'C' || column === 'F'),
'seatRedL':  airplane !== 'PE190' && isSelected && (classType === 'AM_PLUS' || classType === 'PREFERRED' || classType === 'COACH' || classType === 'EXIT_ROW') && (column === 'A' || column === 'D'),
'seatRedR90':  
  (
    (airplane === 'PE190' && isSelected && (classType === 'AM_PLUS' || classType === 'PREFERRED' || classType === 'COACH' || classType === 'EXIT_ROW') && (column === 'B' || column === 'D'))
    || 
    (airplane === 'P7878' && isSelected && (classType === 'AM_PLUS' || classType === 'PREFERRED' || classType === 'COACH' || classType === 'EXIT_ROW') && (column === 'C' || column === 'F' || column === 'J'))
  ),
'seatRedL90':  airplane === 'PE190' && isSelected && (classType === 'AM_PLUS' || classType === 'PREFERRED' || classType === 'COACH' || classType === 'EXIT_ROW') && (column === 'A' || column === 'C')
}">
    <span [ngClass]="{'z-index-10': isSelected,'signlsLetters':isSelected}">{{isSelected ? (displayPassengerSelected | nameinitials ): '' }}</span>
  </button>
</div>
